// Aquí están los thunks relacionados con el cambio de contraseña por olvido
import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "@/services/api";
import {
    fpStartConfirmation,
    fpConfirmSuccess,
    fpConfirmFailure,
    fpResendCodeSuccess,
    fpResendCodeFailure 
} from "./forgotPasswordSlice";

/**
 * 📝 CONFIRM FORGOT PASSWORD — Envía datos de confirmación al backend
 */
export const confirmForgotPassword = createAsyncThunk(
  "confirm/user",
  async ({ email, confirmationCode, password }, { dispatch, rejectWithValue }) => {
    dispatch(fpStartConfirmation());
    try {
        const { data } = await api.post("/auth/confirm-forgot-password", { email, confirmationCode, password });
        dispatch(fpConfirmSuccess());
        return data;
    } catch (error) {
        dispatch(fpConfirmFailure(error.response?.data || error.response?.data?.message || "Error de confirmación"));
        return rejectWithValue(error.response?.data || error.response?.data?.message || "Error de confirmación");
    }
  }
);

export const sendCodeForgotPassword = createAsyncThunk(
    "confirm/resendCode",
    async ({ email }, { dispatch, rejectWithValue }) => {
        dispatch(fpStartConfirmation());
        try {
            const { data } = await api.post("/auth/forgot-password", { email });
            dispatch(fpResendCodeSuccess());
            return data;
        } catch (error) {
            dispatch(fpResendCodeFailure(error.response?.data || error.response?.data?.message || "Error al reenviar el código"));
            return rejectWithValue(error.response?.data || error.response?.data?.message || "Error al reenviar el código");
        }
    }
);